module.exports = __webpack_public_path__ + "static/media/logo.d40c7c53.png";